import { render } from "./ImageStylePanel.vue?vue&type=template&id=c1cc1cba&scoped=true&ts=true"
import script from "./ImageStylePanel.vue?vue&type=script&lang=ts"
export * from "./ImageStylePanel.vue?vue&type=script&lang=ts"

import "./ImageStylePanel.vue?vue&type=style&index=0&id=c1cc1cba&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1cc1cba"]])

export default __exports__